import Calendar from '../../Style-guide/Calendar';

const CalendarSection = ({
  selectedDate,
  setSelectedDate,
  workingDays,
  maxDaysAheadToReserve,
  unavailableDays,
}) => {
  const now = new Date();

  const disabledDates = unavailableDays.map((str) => new Date(str));

  const endMonth = !maxDaysAheadToReserve
    ? undefined
    : new Date(Date.now() + maxDaysAheadToReserve * 86400000);

  const nonWorkingDays = (workingDays || [])
    .filter((d) => !d.isWorkingDay)
    .map((d) => d.dayOfWeek);

  const maxSelectableDate = maxDaysAheadToReserve
    ? new Date(now.getTime() + maxDaysAheadToReserve * 86400000)
    : undefined;

  return (
    <section className='calendar-section section'>
      <Calendar
        selected={selectedDate}
        setSelected={setSelectedDate}
        endMonth={endMonth}
        disabled={[
          { dayOfWeek: nonWorkingDays },
          { after: maxSelectableDate },
          ...disabledDates,
        ]}
      />
    </section>
  );
};

export default CalendarSection;
